(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[195],{

/***/ 3899:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog",
      function () {
        return __webpack_require__(4093);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 111:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6896);




var Banner = function(param) {
    var title = param.title, currentPage = param.currentPage;
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var goHome = function() {
        router.push("/");
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "banner",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "banner-content",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "wrapper",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "banner-title",
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                        className: "breadcrumbs",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: "#",
                                    onClick: goHome,
                                    children: intl.messages.home
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: currentPage
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Banner);


/***/ }),

/***/ 4093:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ blog; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(7582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/api/api.js + 1 modules
var api = __webpack_require__(977);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/components/banner.js
var banner = __webpack_require__(111);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(6896);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./src/assets/images/nardi.jpg
/* harmony default export */ var nardi = ({"src":"/_next/static/media/nardi.17e5d657.jpg","height":641,"width":900,"blurDataURL":"data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoKCgoKCgsMDAsPEA4QDxYUExMUFiIYGhgaGCIzICUgICUgMy03LCksNy1RQDg4QFFeT0pPXnFlZXGPiI+7u/sBCgoKCgoKCwwMCw8QDhAPFhQTExQWIhgaGBoYIjMgJSAgJSAzLTcsKSw3LVFAODhAUV5PSk9ecWVlcY+Ij7u7+//CABEIAAYACAMBIgACEQEDEQH/xAAnAAEBAAAAAAAAAAAAAAAAAAAABgEBAAAAAAAAAAAAAAAAAAAABP/aAAwDAQACEAMQAAAAjAZn/8QAGxABAQABBQAAAAAAAAAAAAAAAgMhAAEGERL/2gAIAQEAAT8AjyMuKlvFHxNLGe1r/8QAGBEAAgMAAAAAAAAAAAAAAAAAAAISEyH/2gAIAQIBAT8ArSTYf//EABgRAAIDAAAAAAAAAAAAAAAAAAACEhMh/9oACAEDAQE/ALHiun//2Q==","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./src/assets/images/chees.jpg
/* harmony default export */ var chees = ({"src":"/_next/static/media/chees.a5e99811.jpg","height":675,"width":900,"blurDataURL":"data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoKCgoKCgsMDAsPEA4QDxYUExMUFiIYGhgaGCIzICUgICUgMy03LCksNy1RQDg4QFFeT0pPXnFlZXGPiI+7u/sBCgoKCgoKCwwMCw8QDhAPFhQTExQWIhgaGBoYIjMgJSAgJSAzLTcsKSw3LVFAODhAUV5PSk9ecWVlcY+Ij7u7+//CABEIAAYACAMBIgACEQEDEQH/xAAoAAEBAAAAAAAAAAAAAAAAAAAABQEBAQAAAAAAAAAAAAAAAAAAAgT/2gAMAwEAAhADEAAAAIwgX//EAB4QAAEEAQUAAAAAAAAAAAAAAAECBRESMQADBCJB/9oACAEBAAE/ANxxby2wODK+tbeE4VbM6//EABgRAAIDAAAAAAAAAAAAAAAAAAABMUGR/9oACAECAQE/AJpYf//EABgRAAIDAAAAAAAAAAAAAAAAAAABAjFx/9oACAEDAQE/AJWsP//Z","blurWidth":8,"blurHeight":6});
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var es = __webpack_require__(1043);
;// CONCATENATED MODULE: ./src/pages/blog.js












var Blog = function() {
    var ref;
    var router = (0,next_router.useRouter)();
    var intl = (0,useIntl/* default */.Z)();
    var locale = (0,es/* useSelector */.v9)(function(state) {
        return state.global.locale;
    });
    ;
    var ref1 = (0,react.useState)(null), blogData = ref1[0], setBlogData = ref1[1];
    var getBlog = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var response;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,api/* getBlogs_req */.XQ)()
                        ];
                    case 1:
                        response = _state.sent();
                        setBlogData(response.data);
                        return [
                            2
                        ];
                }
            });
        });
        return function getBlog() {
            return _ref.apply(this, arguments);
        };
    }();
    var goInnerPage = function(id) {
        router.push("/blog/".concat(id));
    };
    (0,react.useEffect)(function() {
        getBlog();
    }, [
        locale
    ]);
    var addText = function(data) {
        return {
            __html: data
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "blog",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(banner/* default */.Z, {
                        title: intl.messages.blog,
                        currentPage: intl.messages.blog
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex flex-wrap",
                            children: blogData === null || blogData === void 0 ? void 0 : (ref = blogData.posts) === null || ref === void 0 ? void 0 : ref.map(function(item, i) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                    className: "blog-item",
                                    onClick: function() {
                                        return goInnerPage(item.id);
                                    },
                                    children: [
                                        item.id === 108 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "image",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: item.image,
                                                alt: ""
                                            })
                                        }),
                                        item.id === 109 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "image",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: item.image,
                                                alt: ""
                                            })
                                        }),
                                        item.id === 104 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "image",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: item.image,
                                                alt: ""
                                            })
                                        }),
                                        item.id === 103 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "image",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: item.image,
                                                alt: ""
                                            })
                                        }),
                                        item.id === 102 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "image",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: nardi.src,
                                                alt: ""
                                            })
                                        }),
                                        item.id === 101 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "image",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: chees.src,
                                                alt: ""
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "info",
                                            children: [
                                                item.id === 109 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    dangerouslySetInnerHTML: {
                                                        __html: (item === null || item === void 0 ? void 0 : item.content.slice(0, 249)) + "..."
                                                    }
                                                }),
                                                item.id === 108 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    dangerouslySetInnerHTML: {
                                                        __html: (item === null || item === void 0 ? void 0 : item.content.slice(0, 249)) + "..."
                                                    }
                                                }),
                                                item.id === 104 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    dangerouslySetInnerHTML: {
                                                        __html: (item === null || item === void 0 ? void 0 : item.content.slice(0, 249)) + "..."
                                                    }
                                                }),
                                                item.id === 103 && locale !== 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    dangerouslySetInnerHTML: {
                                                        __html: (item === null || item === void 0 ? void 0 : item.content.slice(205, 450)) + "..."
                                                    }
                                                }),
                                                item.id === 103 && locale === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    dangerouslySetInnerHTML: {
                                                        __html: (item === null || item === void 0 ? void 0 : item.content.slice(206, 450)) + "..."
                                                    }
                                                }),
                                                item.id === 101 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    dangerouslySetInnerHTML: {
                                                        __html: (item === null || item === void 0 ? void 0 : item.content.slice(0, 249)) + "..."
                                                    }
                                                }),
                                                item.id === 102 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    dangerouslySetInnerHTML: {
                                                        __html: (item === null || item === void 0 ? void 0 : item.content.slice(0, 249)) + "..."
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                }, i);
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var blog = (Blog);


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(3899); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);